// Owl Carousel

jQuery(document).ready(function() {
    
    jQuery('#home-slider-above-fold').owlCarousel({
        loop: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 1000,
        items: 1, //1 item above 1025px browser width
        itemsDesktop: [1025,1], //1 items between 1025px and 0
        itemsDesktopSmall: false,
        itemsTablet: false, 
        itemsMobile: false, 
        video: true,
        animateIn: 'fadeIn',
        animateOut: 'fadeOutLeft',
    });
    
    jQuery('.home-learning-partners-slider-grid').owlCarousel({
        loop: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplayHoverPause: true,
        autoplaySpeed: 1000,
        
        responsive:{
            0:{
                items:2,
                margin:20,
                slideBy:2,
            },
            641:{
                items:3,
                margin:20,
                slideBy:2,
            },
            1025:{
                items:4,
                margin:30,
                slideBy:3,
            },
            1441: {
                items:4,
                margin:60,
                slideBy:3,
            },
            1921: {
                items:4,
                margin:80,
                slideBy:3,
            },
        },
    });
    
});